import { useLayoutEffect, useRef, useState } from 'react';

/** Never shrink below this, so a short window still shows a usable calendar. */
const MIN_HEIGHT_PX = 480;

/**
 * The height that takes an element from where it sits down to the bottom of
 * the page's scroll area (above any bottom bar), less `bottomGap`. Used as a
 * minimum, so a calendar fills the screen and anything taller scrolls the page.
 * Recomputes on resize.
 */
export function useFillViewport<T extends HTMLElement>(bottomGap: number) {
  const ref = useRef<T>(null);
  const [height, setHeight] = useState<number>();

  useLayoutEffect(() => {
    const measure = () => {
      const el = ref.current;
      if (!el) return;
      const bottom = el.closest('main')?.getBoundingClientRect().bottom ?? window.innerHeight;
      const top = Math.ceil(el.getBoundingClientRect().top);
      setHeight(Math.max(MIN_HEIGHT_PX, Math.floor(bottom - top - bottomGap)));
    };
    measure();
    window.addEventListener('resize', measure);
    return () => window.removeEventListener('resize', measure);
  }, [bottomGap]);

  return { ref, height };
}
